export default function SET_STOP_TEST_TUTOMAT(state, tutomatData) {
    state.tutomat = tutomatData;
}